var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandpaHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29380",
    "data-name": "Group 29380",
    transform: "translate(-489 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(489 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_5_",
    "data-name": "svgexport-17 (5)",
    transform: "translate(507 189.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49948",
    "data-name": "Path 49948",
    d: "M19.361,48.556H1.91l.607-3.414a3.637,3.637,0,0,1,3.583-3h9.071a3.642,3.642,0,0,1,3.585,3Z",
    transform: "translate(-1.91 -30.595)",
    fill: "#5f566a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49949",
    "data-name": "Path 49949",
    d: "M31.915,49.03v4.482h-1.39V49.03a1.588,1.588,0,0,0,.643.135h.1a1.59,1.59,0,0,0,.642-.135Z",
    transform: "translate(-22.494 -35.55)",
    fill: "#3d2f46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28917",
    "data-name": "Group 28917",
    transform: "translate(8.387 15.29)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 0.339,
    cy: 0.339,
    rx: 0.339,
    ry: 0.339,
    fill: "#ced7dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 0.339,
    cy: 0.339,
    rx: 0.339,
    ry: 0.339,
    transform: "translate(0 1.575)",
    fill: "#ced7dc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49950",
    "data-name": "Path 49950",
    d: "M28.367,42.381a2.964,2.964,0,1,1-5.927,0,2.139,2.139,0,0,1,.012-.241h5.9A2.206,2.206,0,0,1,28.367,42.381Z",
    transform: "translate(-16.678 -30.594)",
    fill: "#3d2f46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49951",
    "data-name": "Path 49951",
    d: "M28.823,42.381a2.673,2.673,0,1,1-5.347,0,2.049,2.049,0,0,1,.012-.24h5.323A2.182,2.182,0,0,1,28.823,42.381Z",
    transform: "translate(-17.424 -30.595)",
    fill: "#fab687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49952",
    "data-name": "Path 49952",
    d: "M30.238,33.73v2.547a1.8,1.8,0,0,1-1.716,1.882h-.105A1.8,1.8,0,0,1,26.7,36.277V33.73Z",
    transform: "translate(-19.743 -24.544)",
    fill: "#f8a771"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49953",
    "data-name": "Path 49953",
    d: "M26,6.462a6.747,6.747,0,0,1-.091,1.1c-.419,2.491-2.224,4.363-4.389,4.363s-3.97-1.872-4.389-4.363a6.753,6.753,0,0,1-.091-1.1C17.036,3.623,18.9,1,21.516,1S26,3.628,26,6.462Z",
    transform: "translate(-12.791 -1)",
    fill: "#fab687"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28918",
    "data-name": "Group 28918",
    transform: "translate(4.123 0.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49954",
    "data-name": "Path 49954",
    d: "M24.963,9.28c-1.134-1.6.529-3.6-1-5.017a.8.8,0,0,1,.6-.34c.537,0,.993.75,1.169,1.8.182,1.093.039,2.955-.773,3.557Zm-7.517,0c1.134-1.6-.529-3.6,1-5.017a.8.8,0,0,0-.6-.34c-1.395,0-1.73,4.368-.4,5.357Z",
    transform: "translate(-16.602 -3.924)",
    fill: "#ced7dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28919",
    "data-name": "Group 28919",
    transform: "translate(4.123 0.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49955",
    "data-name": "Path 49955",
    d: "M24.963,9.248c-1.134-1.6.529-3.6-1-5.017.762-.93,1.549.128,1.772,1.46.182,1.093.039,2.955-.773,3.557Zm-7.517,0c1.134-1.6-.529-3.6,1-5.017-.762-.93-1.549.128-1.772,1.46-.182,1.093-.039,2.955.773,3.557Z",
    transform: "translate(-16.602 -3.879)",
    fill: "#ced7dc"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 0.465,
    cy: 0.465,
    rx: 0.465,
    ry: 0.465,
    transform: "translate(6.495 5.176)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 0.465,
    cy: 0.465,
    rx: 0.465,
    ry: 0.465,
    transform: "translate(9.935 5.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49956",
    "data-name": "Path 49956",
    d: "M27.168,17.01q-.015-.129-.041-.257l-.993.2a1.434,1.434,0,0,0-1.29-.885,1.411,1.411,0,0,0-1.025.4,1.35,1.35,0,0,0-.3.406h0a.759.759,0,0,0-.837-.019v0a1.367,1.367,0,0,0-.277-.42,1.424,1.424,0,0,0-1-.441.112.112,0,0,0-.032,0,1.432,1.432,0,0,0-1.3.826l-.771-.2q-.013.153-.018.315l.663.31v0a1.224,1.224,0,0,0-.012.143,1.434,1.434,0,0,0,1.4,1.465h.035a1.428,1.428,0,0,0,1.387-1.789.551.551,0,0,1,.683.015,1.32,1.32,0,0,0-.064.386,1.436,1.436,0,0,0,1.4,1.468h.032a1.436,1.436,0,0,0,1.434-1.4,1.135,1.135,0,0,0-.006-.146Zm-4.583.444a1.2,1.2,0,0,1-.377.85,1.214,1.214,0,1,1-.838-2.093H21.4a1.219,1.219,0,0,1,.852.377,1.2,1.2,0,0,1,.336.835v.032Zm2.2,1.267a1.216,1.216,0,0,1,.026-2.432h.029a1.216,1.216,0,0,1-.055,2.432Z",
    transform: "translate(-14.409 -11.784)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28920",
    "data-name": "Group 28920",
    transform: "translate(3.542 4.589)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 0.92,
    cy: 1.227,
    rx: 0.92,
    ry: 1.227,
    transform: "translate(8.528)",
    fill: "#fab687"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_425",
    "data-name": "Ellipse 425",
    cx: 0.92,
    cy: 1.227,
    rx: 0.92,
    ry: 1.227,
    fill: "#fab687"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49957",
    "data-name": "Path 49957",
    d: "M30.817,32.542a1.454,1.454,0,0,1-2.76-.022.229.229,0,0,1,.228-.284h2.309A.235.235,0,0,1,30.817,32.542Z",
    transform: "translate(-20.713 -23.469)",
    fill: "#663430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49958",
    "data-name": "Path 49958",
    d: "M33.048,34.9a1.474,1.474,0,0,1-1.45.39l0,0A1.026,1.026,0,0,1,33.048,34.9Z",
    transform: "translate(-23.266 -25.287)",
    fill: "#ef4f63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandpaHighlighted);
export default __webpack_public_path__ + "static/media/GrandpaHighlighted.8fdc5a5554d28b0b69b38c60fa425f7b.svg";
export { ForwardRef as ReactComponent };